var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[(_vm.isLayout && !_vm.isFlutter)?_c('Layout'):_c('router-view'),_c('GlobalComponent'),(_vm.userForbidden)?_c('Forbidden',{on:{"logOut":function($event){return _vm.userForbiddenLogOut()}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }